export default __webpack_public_path__ + "static/media/My_goals_blur.48859d9d.jpg";